module.exports = __webpack_public_path__ + "static/img/paleberry_256.baaf0b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paleberry_256.png
// module id = sIAz
// module chunks = 0